export default [
  {
    path: '/webview/timeCost',
    name: 'TimeCostList',
    component: () => import('@/views/pages/webview4app/timeCostList/TimeCostList.vue'),
  },
  {
    path: '/webview/cdkey',
    name: 'CDkey',
    component: () => import('@/views/pages/webview4app/activity/CDkeyList.vue'),
  },
  {
    path: '/webview/activity',
    name: 'Activity',
    component: () => import('@/views/pages/webview4app/activity/Activity.vue'),
  },
  {
    path: '/webview/activityList',
    name: 'Activity',
    component: () => import('@/views/pages/webview4app/activity/ActivityList.vue'),
  },
  {
    path: '/webview/cdkeyList',
    name: 'Activity',
    component: () => import('@/views/pages/webview4app/activity/CDkeyList.vue'),
  },
  {
    path: '/webview/activity/pay4time/details',
    name: 'Activity',
    component: () => import('@/views/pages/webview4app/activity/ActivityDetail.vue'),
  },
  {
    path: '/webview/timeRule',
    name: 'Activity',
    component: () => import('@/views/pages/webview4app/activity/TimeRule.vue'),
  }
];
